import React from "react";
import { IconSize, IconProps, COLOR_SUCCESS } from "../theme";

const GreenTick: React.FC<IconProps> = ({
  color = COLOR_SUCCESS,
  size = IconSize.M,
}) => {
  return (
    <svg
      width={size}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="green-tick"
    >
      <g id="Frame">
        <path
          id="Vector"
          d="M17.9425 6.06705L7.94254 16.067C7.88449 16.1252 7.81556 16.1713 7.73969 16.2027C7.66381 16.2342 7.58248 16.2504 7.50035 16.2504C7.41821 16.2504 7.33688 16.2342 7.26101 16.2027C7.18514 16.1713 7.11621 16.1252 7.05816 16.067L2.68316 11.692C2.56588 11.5748 2.5 11.4157 2.5 11.2499C2.5 11.084 2.56588 10.9249 2.68316 10.8077C2.80044 10.6904 2.9595 10.6245 3.12535 10.6245C3.2912 10.6245 3.45026 10.6904 3.56753 10.8077L7.50035 14.7413L17.0582 5.18267C17.1754 5.0654 17.3345 4.99951 17.5003 4.99951C17.6662 4.99951 17.8253 5.0654 17.9425 5.18267C18.0598 5.29995 18.1257 5.45901 18.1257 5.62486C18.1257 5.79071 18.0598 5.94977 17.9425 6.06705Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default GreenTick;
